export default __webpack_public_path__ + "9157d35d711a3157ee646a0eadcca2a8.svg";